/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuchungsaenderungsAntragDto } from '../../models/buchungsaenderungs-antrag-dto';

export interface GetOffeneBuchungsaenderungsAntraege$Plain$Params {

/**
 * ID des Mitarbeiters, für den die offenen Buchungsaenderungsantraege geholt werden sollen
 */
  mitarbeiterId: string;
}

export function getOffeneBuchungsaenderungsAntraege$Plain(http: HttpClient, rootUrl: string, params: GetOffeneBuchungsaenderungsAntraege$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BuchungsaenderungsAntragDto>>> {
  const rb = new RequestBuilder(rootUrl, getOffeneBuchungsaenderungsAntraege$Plain.PATH, 'get');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BuchungsaenderungsAntragDto>>;
    })
  );
}

getOffeneBuchungsaenderungsAntraege$Plain.PATH = '/v1/mitarbeiter/{mitarbeiterId}/aenderungsAntraege/offen';
